export const moqSubMenu = [{
  path: '/moqs/list',
  component: () => import('@/views/moqs/list.vue'),
  name: 'schemeManagement.moqs.title',
  meta: {
    roles: ['Super Admin', 'Admin', 'Regional Manager', 'Zonal Manager'],
    title: 'schemeManagement.moqs.title',
    noCache: true,
    icon: 'auction'
  }
}, {
  path: '/moqs/edit/:id(\\d+)',
  component: () => import('@/views/moqs/manage.vue'),
  name: 'schemeManagement.moqs.edit',
  props: {
    isEdit: true
  },
  meta: {
    title: 'schemeManagement.moqs.edit',
    noCache: true,
    activeMenu: '/moqs/list',
    hidden: true
  }
}, {
  path: '/moqs/add/',
  component: () => import('@/views/moqs/manage.vue'),
  name: 'schemeManagement.moqs.add',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.moqs.add',
    noCache: true,
    activeMenu: '/moqs/list',
    hidden: true
  }
}, {
  path: '/moqs/import',
  component: () => import('@/views/moqs/import.vue'),
  name: 'schemeManagement.moqs.import',
  props: {
    isEdit: false
  },
  meta: {
    title: 'schemeManagement.moqs.import',
    noCache: true,
    hidden: true
  }
}];